(() => {
  const namespace = 'MenoPlayPDP';
  window[namespace]?.destroy?.();

  const controller = new AbortController();
  const overlays = new Map();
  const overlay = (id, isOpen, close) => {
    if (isOpen) overlays.set(id, close);
    else overlays.delete(id);
    document.body.style.overflow = overlays.size ? 'hidden' : '';
    window.dispatchEvent(new CustomEvent('menoplay:overlay', { detail: { open: overlays.size > 0 } }));
  };

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') [...overlays.values()].at(-1)?.();
  }, { signal: controller.signal });

  window[namespace] = {
    overlay,
    get overlayOpen() { return overlays.size > 0; },
    destroy: () => controller.abort(),
  };
})();
